// extracted by mini-css-extract-plugin
export default {"root":"BirthYearField_root__gSg7H","label":"BirthYearField_label__Wljz+","calculator":"BirthYearField_calculator__+e2A-"};